import SetParams from './ppdNetwork.js';
import axios from 'axios';

class LoanApi extends SetParams {
    constructor() {
        super();
        let baseURL = window.location.origin + '/api/';
        this.service = axios.create({
            baseURL, // api的base_url
            withCredentials: true,
            timeout: 30000 // request timeout
        });

        this.service.interceptors.request.use(
            config => {
                this.config = config;
                return config;
            },
            error => {
                Promise.reject(error);
            }
        );

        this.service.interceptors.response.use(
            response => {
                let { Result, ResultMessage } = response.data;
                let baseUrl = response.config.baseURL;
                let rawUrl = response.config.url.replace(baseUrl, '');
                if (!rawUrl.includes('monitorWebUiService')) {
                    if (Result !== 0 && Result !== 200 && ResultMessage) {
                        super.handleBusinessError(Result, ResultMessage);
                        super.handleError(response);
                    }
                    super.judgeAjaxOver(response.config.url);
                }
                return Promise.resolve(response.data);
            },
            error => {
                if (!error.config.url.includes('monitorWebUiService')) {
                    super.judgeAjaxOver(error.config.url);
                    // 超时
                    if (error.message.includes('timeout')) {
                        super.handleTimeout(error.message, this.config);
                    }
                    // 捕获异常
                    if (error.response && error.response.status) {
                        super.handleError(error.response);
                    }
                }
                return Promise.reject(error);
            }
        );
    }

    sendRequest({
        method,
        url,
        params,
        type, // 网关类型
        headers,
        showNetToast,
        showBusinessToast,
        showLoading,
        needCp = true,
        loadWidthMask = false,
        noToLogin = false // 不引导登录
    }) {
        return super.sending(
            url,
            params,
            method,
            headers,
            showNetToast,
            showBusinessToast,
            showLoading,
            type, // 网关类型
            needCp,
            loadWidthMask,
            noToLogin
        );
    }
}
const loanApi = new LoanApi();
export default loanApi.sendRequest.bind(loanApi);
